const stringToColor = (string: string): string => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  const darkenFactor = 0.7;

  for (i = 0; i < 3; i += 1) {
    let value = (hash >> (i * 8)) & 0xff;

    value = Math.floor(value * darkenFactor);
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};

export const getAvatarPropsByName = (
  name: string,
): {
  sx: { bgcolor: string; width: number; height: number; fontSize: number };
  children: string;
} => {
  const safe = (name || "").trim();
  const parts = safe.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "?";
  const second = parts[1]?.[0] ?? "";

  return {
    sx: {
      bgcolor: stringToColor(safe || first),
      width: 24,
      height: 24,
      fontSize: 10,
    },
    children: `${first}${second}`.toUpperCase(),
  };
};
